<template>
  <div style="box-sizing: border-box; border-radius: 6px; background-color: #474e5d; font-family: Helvetica, sans-serif;" ref="timeline_container" id="timeline-container">
    <div class="timeline">
      <div v-for="(item, index) in items" :key="index" :class="timelineItemClass(index)">
          <div class="timeline-content">
            <p>{{item[title_prop]}}</p>
            <p>{{item[body_prop]}}</p>
          </div>
      </div>

        <!-- <div class="container right">
            <div class="content">
            <p>26/02/2019</p>
            <p>APPROVED FAST-TRACK EMAIL SENT</p>
            </div>
        </div>
        <div class="container left">
            <div class="content">
            <p>26/02/2019</p>
            <p>APPROVED FAST-TRACK</p>
            </div>
        </div>
        <div class="container right">
            <div class="content">
            <p>26/02/2019</p>
            <p>SUBMITTED</p>
            </div>
        </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimelineDisplay',
  props: {
    items: { required: true, type: Array },
    title_prop: { required: true, type: String },
    body_prop: { required: true, type: String }
  },
  data: () => {
    return {
      windowWidth: window.innerWidth
    }
  },
  methods: {
    timelineItemClass(index) {
      //:class=" index % 2 == 0 ? 'container right' : 'container left'"
      if (this.windowWidth > 990) {
        return index % 2 == 0 ? 'timeline-container timeline-container-right' : 'timeline-container timeline-container-left';
      } else {
        return 'timeline-container timeline-container-right';
      }
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    }
  }
}
</script>
